// Shared types + defaults for the home hero carousel.
// Admins manage slides in Admin → Blog & content → Home carousel.
// When no slides exist in the database, the built-in slides are used.
import { SITE_IMAGE_SLOTS, resolveSiteImage, type SiteImageOverride } from "@/lib/site-images";

export type HeroSlide = {
  id: string;
  position: number;
  enabled: boolean;
  image_url: string;
  alt: string;
  link_path: string;
  cta_label: string | null;
  learn_label: string | null;
};

export type HeroCarouselSettings = {
  autoplay: boolean;
  autoplay_ms: number;
};

export const DEFAULT_HERO_SETTINGS: HeroCarouselSettings = {
  autoplay: true,
  autoplay_ms: 6500,
};

const BUILT_IN = [
  { slot: "hero_slide_liver", handle: "liver-biome-plus" },
];

/** Built-in slides derived from the existing website-picture slots. */
export function builtInHeroSlides(overrides?: SiteImageOverride[]): HeroSlide[] {
  return BUILT_IN.map((s, i) => {
    const img = resolveSiteImage(s.slot, overrides);
    return {
      id: s.slot,
      position: i,
      enabled: true,
      image_url: img.url,
      alt: img.alt,
      link_path: `/products/${s.handle}`,
      cta_label: null,
      learn_label: null,
    };
  });
}

export const HERO_IMAGE_SLOT_HINTS = SITE_IMAGE_SLOTS.map((s) => s.slot);

export function sortSlides(slides: HeroSlide[]): HeroSlide[] {
  return [...slides].sort((a, b) => a.position - b.position);
}
